import { render, staticRenderFns } from "./business_integral_order.vue?vue&type=template&id=cb2d4ed6"
import script from "./business_integral_order.vue?vue&type=script&lang=ts"
export * from "./business_integral_order.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports